const API_HOST = "https://carts-api.dev2.scrij.com";

export const environment = {
  production: false,
  apiUrl: `${API_HOST}/api/v1`,
  apiV2Url: `${API_HOST}/api/v2`,
  apiHost: API_HOST,
};
